var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { FileMakerLists } from '../FileMakerList';
export class FileMakerSearch extends Component {
    constructor(isDebugEnabled = false) {
        super('FileMakerList', false);
        this.isLocationLoading = false;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('.filemaker-list').length > 0) {
                $('.filemaker-search').on('submit', (event) => {
                    event.preventDefault();
                });
                $('.filemaker-search-button').on('click', () => {
                    $('#filter-tags, #filter-places').removeClass('show');
                    let from = $('.filemaker-search-field[data-parameter="from"]').val().replace(/\./gi, '/');
                    let to = $('.filemaker-search-field[data-parameter="to"]').val().replace(/\./gi, '/');
                    ;
                    if (to === '')
                        to = from;
                    let tags = [];
                    let awards = [];
                    let city = '';
                    let region = '';
                    let country = '';
                    FilterList.items.forEach((item) => {
                        if (item.type === 'tag')
                            tags.push(item.id);
                        if (item.type === 'award')
                            awards.push(item.id);
                        if (item.type === 'place') {
                            if (item.category === 'ville') {
                                city = item.id;
                                region = item.region;
                            }
                            if (item.category === 'pays')
                                country = item.id;
                        }
                    });
                    FileMakerLists.reset({
                        text: $('.filemaker-search-field[data-parameter="text"]').val(),
                        from: from,
                        to: to,
                        tags: tags,
                        awards: awards,
                        city: city,
                        region: region,
                        country: country,
                        excluded_shows: $('#excluded-shows').val()
                    });
                    FileMakerLists.load();
                });
                $('.filemaker-search-reset-button').on('click', () => {
                    $('.filemaker-search-field').val('');
                    FilterList.clear();
                    FileMakerSearch.toggleSeachButtonsState();
                    $('.filemaker-list, .filemaker-list-count').empty();
                    if ($('.filemaker-list').data('autoload') === 'true')
                        $('.filemaker-search-button').trigger('click');
                    $('.nav-tabs').addClass('d-none');
                    location.hash = '';
                });
                $('.filemaker-search-field').on('change', () => {
                    FileMakerSearch.toggleSeachButtonsState();
                });
            }
            $('.filter').on('click', (event, filter) => {
                const checkbox = filter.find('input[type="checkbox"]');
                if (checkbox.get(0).checked) {
                    FilterList.add(checkbox.data('type'), checkbox.val(), filter.find('label').text());
                }
                else {
                    FilterList.remove(checkbox.data('type'), checkbox.val());
                }
            });
            $('body').on('click', '.active-filter', (event, element) => {
                FilterList.remove(element.data('type'), element.data('id'));
            });
            let debounceTimout = 0;
            $('#filemaker-search-search-location').on('keydown', (event, input) => {
                if (event.key === 'Enter')
                    event.preventDefault();
            }).on('keyup', (event, input) => {
                if (input.val().length < 3)
                    return;
                if (event.key === 'Enter' && !this.isLocationLoading) {
                    $('#filter-tags, #filter-places').removeClass('show');
                    const checkbox = $('#location-list [data-type="location"]').first();
                    checkbox.get(0).checked = true;
                    this.selectLocation(checkbox);
                    return;
                }
                clearTimeout(debounceTimout);
                debounceTimout = window.setTimeout(() => {
                    this.loadLocations(input);
                }, 400);
            });
            $('body').on('click', 'input[data-type="location"]', (event, checkbox) => {
                this.selectLocation(checkbox);
            });
            $('a[href="#filter-places"]').on('click', () => {
                setTimeout(() => {
                    if ($('#filter-places').hasClass('show')) {
                        $('#filemaker-search-search-location').get(0).focus();
                    }
                    else {
                        $('#location-list').empty().addClass('d-none');
                        $('#filemaker-search-search-location').val('');
                    }
                }, 500);
            });
            $('.filemaker-search-copy-html').on('click', (event) => {
                event.preventDefault();
                const html = $('#newsletter-shows').html();
                try {
                    const clipboardItem = new ClipboardItem({
                        'text/html': new Blob([html], { type: 'text/html' }),
                        'text/plain': new Blob([html], { type: 'text/plain' })
                    });
                    navigator.clipboard.write([clipboardItem]).then(() => {
                        alert('Contenu copié avec succès !');
                    }, (err) => {
                        alert('Une erreur est survenue lors de la copie du contenu.\nVeuillez copier le bloc ci-dessus manuellement.');
                    });
                }
                catch (err) {
                    alert('Le copie automatique du contenu fonctionne uniquement avec les dernières versions de Chrome ou Safari.');
                }
            });
            this.success();
        });
    }
    selectLocation(checkbox) {
        FilterList.remove('place', '0');
        if (checkbox.get(0).checked) {
            $('input[data-type="location"]').forEach((other_checkbox) => {
                other_checkbox.checked = false;
            });
            checkbox.get(0).checked = true;
            FilterList.add('place', checkbox.val(), checkbox.next().text(), checkbox.data('category'), checkbox.data('region'));
        }
    }
    loadLocations(input) {
        return __awaiter(this, void 0, void 0, function* () {
            this.isLocationLoading = true;
            input.next().addClass('d-flex').removeClass('d-none');
            $('#location-list').addClass('d-none');
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    'action': 'get_locations',
                    'search': input.val(),
                },
                dataType: 'json',
            });
            $('#location-list').empty();
            if (response.length > 0) {
                $('#location-list').removeClass('d-none');
                response.forEach((location) => {
                    const element = $.parseHTML('<div class="filter"><input data-type="location" type="checkbox" id="location-' + location.id + '" value="' + location.title + '" data-category="' + location.category + '" data-region="' + location.region + '" /><label for="location-' + location.id + '">' + location.title + '</label></div>');
                    $('#location-list').append(element);
                });
            }
            input.next().removeClass('d-flex').addClass('d-none');
            this.isLocationLoading = false;
        });
    }
    static toggleSeachButtonsState() {
        let filledInputCount = 0;
        $('.filemaker-search-field').each((element) => {
            if (element.val() !== '')
                filledInputCount++;
        });
        if (FilterList.items.length > 0)
            filledInputCount += 1;
        if (filledInputCount > 0) {
            $('.filemaker-search-reset-button').removeClass('d-none');
            $('.filemaker-search-button, .filemaker-search-copy-html').removeClass('disabled');
        }
        else {
            $('.filemaker-search-reset-button').addClass('d-none');
            $('.filemaker-search-button, .filemaker-search-copy-html').removeClass('disabled');
        }
    }
    static updateSearchFields(query) {
        // restore text, from and to fields
        $('.filemaker-search-field').each((element) => {
            const parameter = element.data('parameter');
            if (['from', 'to'].includes(parameter))
                query[parameter] = query[parameter].replace(/\//gi, '.');
            if (query[parameter])
                element.val(query[parameter]);
        });
        // restore tags
        ['tags'].forEach((type) => {
            if (query[type]) {
                query[type].forEach((id) => {
                    const checkbox = $('.filter input[data-type="tag"][value="' + id + '"]');
                    if (checkbox.length > 0) {
                        checkbox.get(0).checked = true;
                        FilterList.add(checkbox.data('type'), checkbox.val(), checkbox.next().text());
                    }
                });
            }
        });
        // restore region, city and country
        ['city', 'country'].forEach((type) => {
            if (query[type]) {
                const name = query[type].replace(/~/gi, '');
                console.log(name);
                const category = type == 'country' ? 'pays' : 'ville';
                const region = type == 'city' ? query['region'] : '';
                FilterList.add('place', name, name, category, region);
            }
        });
        $('.filemaker-search-reset-button').removeClass('d-none');
    }
}
class FilterList {
    static add(type, id, title, category, region) {
        this.items.push({ type: type, id: id, title: title, category: category, region: region });
        this.update();
    }
    static remove(type, id) {
        this.items = this.items.filter((item) => {
            if (type === 'place') {
                return item.type !== type;
            }
            else {
                return item.type !== type || item.id !== id;
            }
        });
        if (type !== 'place')
            $('.filter input[data-type="' + type + '"][value="' + id + '"]').get(0).checked = false;
        this.update();
    }
    static clear() {
        this.items = [];
        $('.filter input').forEach((checkbox) => {
            checkbox.checked = false;
        });
        this.update();
    }
    static update() {
        $('.filter-list').empty();
        this.items.forEach((item) => {
            const element = $.parseHTML('<div class="active-filter" data-type="' + item.type + '" data-id="' + item.id + '" data-category="' + item.category + '">' + item.title + '</div>');
            $('.filter-list').append(element);
        });
        FileMakerSearch.toggleSeachButtonsState();
    }
}
FilterList.items = [];
